module.exports = __webpack_public_path__ + "img/gentlemen-club-carousel-13.584dbb69.png";